export enum FindAllCarsSort {
  LICENCE_PLATE = 'car.licencePlate',
  FIN = 'car.fin',
  MILAGE = 'car.milage',
  MAKE = 'make.name',
  MODEL = 'vehicleType.model',
  AVAILABLE_FROM = 'car.availableFrom',
  LAST_TUV_DATE = 'car.lastTuvDate',
  TYRE_CONDITION_PRIORITY = 'tyre_condition_priority',
  NEXT_ALLOCATION_START_DATE = 'car_next_allocation_start_date',
}
